module.exports = __webpack_public_path__ + "static/media/googleplay.326cf3dd.png";